import React from 'react';
import { DislikeOutlined, FlagOutlined, LikeOutlined, WarningOutlined } from '@ant-design/icons';

export const suggestedQuestions = [
  'Does the pharmacy need a Part D denial first?',
  'Does BMI use current BMI or initiation BMI?',
  'Can Bridge be used for type 2 diabetes?',
  'Does LIS reduce the $50 copay?',
  'Can PA be submitted before the pharmacy claim, and are chart notes needed?',
];

export const screeningFollowUpQuestions = [
  'Based on the screening result, what should the prescriber do next?',
  'What should the pharmacy do after the Bridge claim rejects for PA?',
  'Does this patient need a Part D denial before Bridge?',
  'What should be documented on the PA form?',
];

export const PHI_BLOCKED_USER_MESSAGE = '[Input blocked because it may contain patient identifiers.]';
export const PHI_BLOCKED_ANSWER =
  "I can't process patient-identifying information. Please remove names, dates of birth, Medicare IDs, MRNs, addresses, ZIP codes, phone numbers, emails, exact service dates, and other identifiers. You can still ask using de-identified facts such as BMI, diagnosis category, Medicare Part D coverage status, and prior GLP-1 Part D coverage.";

export const feedbackOptions = [
  { value: 'helpful', label: 'Helpful', icon: <LikeOutlined /> },
  { value: 'not_helpful', label: 'Not helpful', icon: <DislikeOutlined /> },
  { value: 'source_wrong', label: 'Source looks wrong', icon: <WarningOutlined /> },
  { value: 'need_human_review', label: 'Need human review', icon: <FlagOutlined /> },
];

export const yesNoUnknownOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'unknown', label: 'Not sure' },
];

export const bmi30ComorbidityOptions = [
  { value: 'hfpef', label: 'HFpEF' },
  { value: 'uncontrolled_hypertension_two_meds', label: 'Uncontrolled HTN on 2+ medications' },
  { value: 'ckd_stage_3a_or_above', label: 'CKD stage 3a or above' },
  { value: 'none', label: 'None of these' },
  { value: 'unknown', label: 'Not sure' },
];

export const bmi27ComorbidityOptions = [
  { value: 'prediabetes', label: 'Pre-diabetes' },
  { value: 'previous_mi', label: 'Previous MI' },
  { value: 'previous_stroke', label: 'Previous stroke' },
  { value: 'symptomatic_pad', label: 'Symptomatic PAD' },
  { value: 'none', label: 'None of these' },
  { value: 'unknown', label: 'Not sure' },
];

export const allComorbidityOptions = [...bmi30ComorbidityOptions, ...bmi27ComorbidityOptions].filter(
  (option, index, options) => options.findIndex((item) => item.value === option.value) === index
);

export const initialScreeningValues = {
  eligible_part_d_coverage: null,
  received_glp1_through_part_d: null,
  has_part_d_diagnosis: null,
  weight_management_only: null,
  bmi_at_initiation: null,
  comorbidities: [],
};

export const screeningFieldLabels = {
  eligible_part_d_coverage: 'Eligible Medicare Part D plan coverage',
  received_glp1_through_part_d: 'Received a GLP-1 through Part D plan',
  has_part_d_diagnosis: 'Type 2 diabetes, moderate-to-severe sleep apnea, or MASH',
  weight_management_only: 'Weight-management-only prescribing use',
  bmi_at_initiation: 'BMI at therapy initiation',
  comorbidities: 'Qualifying comorbidities',
};

export const initialMessages = [];
